import { Theme } from "@mui/material/styles";

import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((_theme: Theme) => ({
  card: {
    borderRadius: 0,
    height: "100%",
    padding: "32px",
  },

  content: {
    padding: "0 !important",
  },

  header: {
    marginBottom: "16px",
    padding: 0,
    "& .MuiCardHeader-title": {
      overflow: "hidden",
      color: "#475467",
      textOverflow: "ellipsis",
      fontFamily: "Manrope",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "24px", // 150%
      letterSpacing: "0.15px",
    },
  },

  skeleton: {
    width: "100%",
  },
}));
